import { empty } from "./empty";

export const minutesForHumans = function(minutes) {
  if (minutes === 0) return 0;
  if (empty(minutes) || isNaN(parseInt(minutes))) return null;
  minutes = parseInt(minutes);
  if (minutes <= 60) return minutes + " min";

  const hours = Math.floor(minutes / 60);
  let result = hours + " h";
  const leftoverMinutes = minutes % 60;
  if (leftoverMinutes === 0) return result;

  result += " " + leftoverMinutes + " min";
  return result;
};
